import React, { useId } from 'react';
import './crm-ui.scss';

function CrmTooltip({ content, children, placement = 'top', className = '' }) {
  const id = useId();
  if (!content) return children;

  return (
    <span className={`crm-tooltip crm-tooltip--${placement} ${className}`.trim()}>
      {React.cloneElement(children, { 'aria-describedby': id })}
      <span id={id} className="crm-tooltip__bubble" role="tooltip">
        {content}
      </span>
    </span>
  );
}

export default CrmTooltip;
